import clsx from "clsx"
import React from "react"

import PageGrid from "../PageGrid"
import QuoteSingle from "../QuoteSingle"

interface SubHeroProps {
  quotee?: string
  quoteeTitle?: string
  quote?: string
  quoteeImage?: {
    url: string
    title: string
    width: number
    height: number
  }
  descriptions: React.ReactNode
  title?: string
  image?: React.ReactNode | any
  hasSolutionsHero?: boolean
  wrapperClass?: string
}

const SubHeroSection: React.FC<SubHeroProps> = ({
  quotee,
  quoteeTitle,
  quote,
  quoteeImage,
  descriptions,
  title,
  image,
  hasSolutionsHero = true,
  wrapperClass,
}) => (
  <div
    className={clsx(
      "pb-16 bg-white-100 lg:pb-24 xl:pb-28 text-gray-90",
      hasSolutionsHero ? "" : "pt-16 lg:pt-24 xl:pt-28",
      wrapperClass,
    )}
  >
    {title && (
      <PageGrid className="p-4">
        <div className="mb-6 md:mb-10 col-span-full lg:col-span-7">
          <h3 className="text-heading1 md:headline4">{title}</h3>
        </div>
      </PageGrid>
    )}
    <PageGrid className="flex lg:justify-center lg:align-center">
      <div className="p-4 col-span-full md:col-span-2 lg:col-span-6 lg:content-center body3 lg:body2">
        {Array.isArray(descriptions)
          ? descriptions.map((description, index) => {
              if (typeof description === "string") {
                return (
                  <p
                    className={clsx(
                      index === descriptions.length - 1 ? "" : "mb-4",
                    )}
                    key={description}
                  >
                    {description}
                  </p>
                )
              }
              return description
            })
          : descriptions}
      </div>
      <div className="relative mt-8 lg:mt-0 col-span-full md:col-span-2 lg:col-span-6 lg:content-center">
        {quotee && (
          <QuoteSingle
            quotee={quotee}
            quoteeTitle={quoteeTitle}
            quote={quote}
            quoteeImage={quoteeImage}
          />
        )}
        {image && image}
      </div>
    </PageGrid>
  </div>
)
export default SubHeroSection
